import { api } from './api';

export interface AuditLogEntry {
  id: string;
  action: string;
  entityType: string;
  entityId: string | null;
  ipAddress: string | null;
  userAgent: string | null;
  metadata: unknown;
  createdAt: string;
  user: { id: string; firstName: string; lastName: string; email: string } | null;
}

export interface AuditLogDetail extends AuditLogEntry {
  changes: unknown;
}

export interface AuditLogPage {
  data: AuditLogEntry[];
  nextCursor: string | null;
}

export interface AuditFilters {
  user_id?: string;
  action?: string;
  entity_type?: string;
  entity_id?: string;
  date_from?: string;
  date_to?: string;
  cursor?: string;
  limit?: number;
}

function toQuery(filters: AuditFilters): string {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v) params.set(k, String(v));
  }
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export const auditApi = {
  list: (token: string, filters: AuditFilters = {}) =>
    api.get<AuditLogPage>(`/api/v1/audit-logs${toQuery(filters)}`, { accessToken: token }),
  get: (token: string, id: string) =>
    api.get<AuditLogDetail>(`/api/v1/audit-logs/${id}`, { accessToken: token }),
};
